module.exports = __webpack_public_path__ + "img/Girl_030001.8acee239.png";